/**
 * Перелік звітів (`SPEC-027` §3.4, К-02, К-03): одне джерело для списку на
 * `/report` і для вкладок між звітами — як `dataSource` легасі
 * (`ReportIndexPage.jsx:9-22`), з якого будувались і список, і `TopMenu`.
 * Назви — дослівно з легасі (`translation.json:610-611,626`).
 */
export interface IReportListItem {
    /** Ключ сторінки ядра (`pageConfig.key`). */
    key: string
    /** Сегмент адреси після `/report/`. */
    path: string
    title: string
}

export const REPORT_SECTION_PATH = '/report'

export const REPORT_LIST: readonly IReportListItem[] = [
    { key: 'Report.LogisticiansFinancial', path: 'logisticians-financial', title: 'Звіт по логістам - фінансовий' },
    { key: 'Report.LogisticiansInvolvement', path: 'logisticians-involvement', title: 'Звіт по залученню логістів' },
    { key: 'Report.ClientLosses', path: 'client-losses', title: 'Звіт по програним заявкам' },
]

export const reportUrl = (item: IReportListItem): string => `${REPORT_SECTION_PATH}/${item.path}`
